import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd, ActivationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';
import * as TokenInformationActions from '../app/tokeninformation/store/token-information.actions';
import { Store } from '@ngrx/store';
import * as fromApp from './store/app.reducer';
import { TokenInformation } from './tokeninformation/store/token-information.model';
import { DashboardInformationService } from './shared/services/dashboard-information.service';
import { BaseService } from './shared/services/base.service';
import { Permission } from './permissions/store/permission.model';
import * as PermissionActions from './permissions/store/permission.actions';
import * as DashboardInformationActions from './dashboardInformation/store/dashboard-information.actions';
import * as LoggedInUserInformationActions from '../app/storeInformation/loogedInUserInformation/store/loggedinuser-information.actions';
import * as ConfigurationActions from './configurations/store/configurations.actions';
import * as ScreenInformationActions from './screeninformation/store/screeninformation.actions';
import { DashboardInformation } from './dashboardInformation/store/dashboard-information.model';
import { localStorageInformationId, storeInformationId, systemConstants } from './shared/modals/common';
import { LoggedInUserInformation } from './storeInformation/loogedInUserInformation/store/loggedinuser-information.model';
import { Configurations } from './configurations/store/configurations.model';
import { ScreenInformation } from './screeninformation/store/screeninformation.model';
// import { ScreenInformation } from './storeInformation/screenInformation/store/screeninformation.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    subscription: Subscription;

    constructor(private router: Router, private dashboardInformationService: DashboardInformationService,
        private store: Store<fromApp.AppState>, private baseService: BaseService) {
        router.events.subscribe(val => {
            if (val instanceof ActivationEnd) {
                let _routeConfigpath = val.snapshot.routeConfig.path.split('/')[val.snapshot.routeConfig.path.split('/').length - 1];
                let _routerStateUrl = val.snapshot['_routerState'].url.split('/')[val.snapshot['_routerState'].url.split('/').length - 1];
                if (val['snapshot'] && val.snapshot.routeConfig 
                    && _routeConfigpath === _routerStateUrl) {
                    localStorage.setItem('Task', val['snapshot'].data.taskId);
                    localStorage.setItem('Screen', val['snapshot'].data.screenId);
                }
            }

        });
    }

    ngOnInit() {
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(() => window.scrollTo(0, 0));
        this.dashboardInformationService.generateToken().subscribe(
            data => {
                const result = data;
                var info = jwt_decode(result.data);
                const tokenInformation: TokenInformation = {
                    userId: info.userId,
                    storeLocationId: info.storeLocationId,
                    orgId: info.orgId
                };
                this.store.dispatch(new TokenInformationActions.AddTokenInformation(tokenInformation));
                this.baseService.setLocalData(localStorageInformationId.userTokenInfo, tokenInformation);

                // const permission = this.baseService.callAPIWithPromis('/DashboardInformation/GetPermissionData', null);
                const promise = this.baseService.callAPIWithPromis('/baseframework/LoggedInUser', {
                    "StoreLocationId": parseInt(info.storeLocationId),
                    "UserId": parseInt(tokenInformation.userId),
                    "orgid": info.orgId,
                    "Token": systemConstants.bodyToken
                });
                promise.then((data) => {
                    if (data['data'] != '') {
                        var res_item = this.baseService.Decrypt(data['data']);
                        let loggedInUserInformation: LoggedInUserInformation;
                        loggedInUserInformation = res_item;
                        this.baseService.setLocalData(localStorageInformationId.loggedInUserInformation, loggedInUserInformation);
                        this.store.dispatch(new LoggedInUserInformationActions.AddLoggedInUserInformation(loggedInUserInformation));
                    }
                }, (error) => {
                    console.log("Promise rejected with " + JSON.stringify(error));
                });
                const configpromise = this.baseService.callAPIWithPromis('/CommonDll/GetConfigurationItemList', null);
                configpromise.then((data) => {
                    if (data['data'] != '') {
                        var res_item = this.baseService.Decrypt(data['data']);
                        let configuationValues: Configurations;
                        configuationValues = JSON.parse(res_item);
                        this.store.dispatch(new ConfigurationActions.AddConfiguration(configuationValues));
                    }
                }, (error) => {
                    console.log("Promise rejected with " + JSON.stringify(error));
                });
                const screenpromise = this.baseService.callAPIWithPromis('/CommonDll/GetAllScreen', null);
                screenpromise.then((data) => {
                    if (data['data'] != '') {
                        
                        var res_item = this.baseService.Decrypt(data['data']);
                        let screenValues: ScreenInformation[];
                        screenValues = res_item;
                        this.store.dispatch(new ScreenInformationActions.AddScreenInformation(screenValues));
                    }
                }, (error) => {
                    console.log("Promise rejected with " + JSON.stringify(error));
                });
                const dashboardinfopromise = this.baseService.callAPIWithPromis('/dashboardInformation/getDashboardInformation', null);
                dashboardinfopromise.then((data) => {
                    if (data['data'] != '') {
                        var dashboardInformation = JSON.parse(this.baseService.Decrypt(data['data']));
                        //const dashboardInformation = JSON.parse(data['data']);
                        if (dashboardInformation.IsUserLoggedIn) {
                            const menuItemsDynamic = dashboardInformation.HorizontalUserMenuList ?
                                JSON.parse(dashboardInformation.HorizontalUserMenuList) : '';

                            this.baseService.setLocalData('menuItemsDynamic', menuItemsDynamic);
                            const permissions = dashboardInformation.PermissionListData ?
                                dashboardInformation.PermissionListData : [];
                            this.baseService.setLocalData('permissions', permissions);
                            this.baseService.setLocalData('dashboardInformation', dashboardInformation);
                            this.store.dispatch(new PermissionActions.AddPermission(permissions));
                            const dashboardInformation1: DashboardInformation = new DashboardInformation(dashboardInformation.WelcomeText, dashboardInformation.DashboardUsername, dashboardInformation.UserProfileInformation);
                            this.store.dispatch(new DashboardInformationActions.AddDashboardInformation(dashboardInformation1));
                            this.baseService.setLocalData(localStorageInformationId.loggedInUserInformation, dashboardInformation.UserProfileInformation);
                            this.store.dispatch(new LoggedInUserInformationActions.AddLoggedInUserInformation(dashboardInformation.UserProfileInformation));
                        } else {
                            var loginPageUrl = 'Pages/Baseframework/Security/Login';
                            window.location.href = loginPageUrl;
                        }
                    }
                }, (error) => {
                    console.log("Promise rejected with " + JSON.stringify(error));
                });

            },
            err => console.error(err)
        );



    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }



}